import { withInstall } from '@vuesax-alpha/utils'

import Alert from './src/alert.vue'

export const VsAlert = withInstall(Alert)
export default VsAlert

export * from './src/alert'
